import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["DataField"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDataFieldCategoryByMeasuringPoint: build.query<
        GetDataFieldCategoryByMeasuringPointApiResponse,
        GetDataFieldCategoryByMeasuringPointApiArg
      >({
        query: (queryArg) => ({ url: `/DataField/Category/${queryArg}` }),
        providesTags: ["DataField"],
      }),
      getDataFieldDataClassByMeasuringPoint: build.query<
        GetDataFieldDataClassByMeasuringPointApiResponse,
        GetDataFieldDataClassByMeasuringPointApiArg
      >({
        query: (queryArg) => ({ url: `/DataField/DataClass/${queryArg}` }),
        providesTags: ["DataField"],
      }),
      getDataField: build.query<GetDataFieldApiResponse, GetDataFieldApiArg>({
        query: (queryArg) => ({
          url: `/DataField`,
          params: {
            measuringPoint: queryArg.measuringPoint,
            dataClass: queryArg.dataClass,
            manufacturer: queryArg.manufacturer,
            category: queryArg.category,
          },
        }),
        providesTags: ["DataField"],
      }),
      getDataFieldDataFieldsForAnalysis: build.query<
        GetDataFieldDataFieldsForAnalysisApiResponse,
        GetDataFieldDataFieldsForAnalysisApiArg
      >({
        query: () => ({ url: `/DataField/DataFieldsForAnalysis` }),
        providesTags: ["DataField"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dataFieldApi };
export type GetDataFieldCategoryByMeasuringPointApiResponse =
  /** status 200 OK */ DataClassCategoryDto[];
export type GetDataFieldCategoryByMeasuringPointApiArg = string;
export type GetDataFieldDataClassByMeasuringPointApiResponse =
  /** status 200 OK */ DataClassDto[];
export type GetDataFieldDataClassByMeasuringPointApiArg = string;
export type GetDataFieldApiResponse =
  /** status 200 OK */ DataFieldDescriptionDto[];
export type GetDataFieldApiArg = {
  measuringPoint: string;
  dataClass?: string;
  manufacturer?: string;
  category?: string;
};
export type GetDataFieldDataFieldsForAnalysisApiResponse =
  /** status 200 OK */ DataFieldDtoRead[];
export type GetDataFieldDataFieldsForAnalysisApiArg = void;
export type DataClassCategoryDto = {
  dataClass: string;
  shortName: string;
  manufacturer: string;
  description: string;
  category: string;
};
export type DataClassDto = {
  id: number;
  manufacturer: string;
  name: string;
  description?: string | null;
  shortName: string;
  isIntermittent: boolean;
};
export type DataFieldDescriptionDto = {
  description: string;
  name: string;
  unit?: string | null;
  subCategory?: string | null;
  id?: number;
  category?: string | null;
  dataClass?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type DataFieldDto = {
  id: number;
  dataClass: string;
  name: string;
  description?: string | null;
  analysisCategory?: string | null;
  category?: string | null;
  subcategory?: string | null;
  unit?: string | null;
  isUsedForPqIndex: boolean;
  isUsedForAnomaly: boolean;
  isUsedForTrend: boolean;
  isUsedForCorrelation: boolean;
  twoTailedCalculation: boolean;
  pqIndexCategory?: string | null;
};
export type DataFieldDtoRead = {
  id: number;
  dataClass: string;
  name: string;
  description?: string | null;
  analysisCategory?: string | null;
  category?: string | null;
  subcategory?: string | null;
  unit?: string | null;
  isUsedForPqIndex: boolean;
  isUsedForAnomaly: boolean;
  isUsedForTrend: boolean;
  isUsedForCorrelation: boolean;
  twoTailedCalculation: boolean;
  pqIndexCategory?: string | null;
  isVoltageDataField: boolean;
  isThdDataField: boolean;
  isSimpleHarmonic: boolean;
  isInterHarmonic: boolean;
  isHighFrequencyHarmonic: boolean;
};
export const {
  useGetDataFieldCategoryByMeasuringPointQuery,
  useLazyGetDataFieldCategoryByMeasuringPointQuery,
  useGetDataFieldDataClassByMeasuringPointQuery,
  useLazyGetDataFieldDataClassByMeasuringPointQuery,
  useGetDataFieldQuery,
  useLazyGetDataFieldQuery,
  useGetDataFieldDataFieldsForAnalysisQuery,
  useLazyGetDataFieldDataFieldsForAnalysisQuery,
} = injectedRtkApi;
